import type { UpdateWizardMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateWizardDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { UpdateWizardMutationVariables } from '../nativeMutationInputs';
import type { FrontendRouterInputs } from '../routerInputs';

type UpdateWizardTRPCInput = FrontendRouterInputs['wizard']['update'];

export const useUpdateWizard = createMutationHook({
  name: 'updateWizard',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.wizard.update.mutationOptions({ onSuccess }),
  mapInput: (
    variables: UpdateWizardMutationVariables
  ): UpdateWizardTRPCInput => {
    const obj = variables.object;

    return {
      RiskId: obj?.RiskId ?? '',
      CurrentStep: obj?.CurrentStep ?? 0,
      Status: obj?.Status,
    };
  },
  invalidate: (trpc) => [
    trpc.frontend.wizard.wizards.queryKey(),
    trpc.frontend.wizard.wizardById.queryKey(),
  ],
  mapResponse: (trpcData: { affectedRows: number }): UpdateWizardMutation => ({
    updateWizardById: {
      __typename: 'GenericMutationOutput',
      affected_rows: trpcData.affectedRows,
    },
  }),
  graphqlDocument: UpdateWizardDocument,
  graphqlVariables: (variables: UpdateWizardMutationVariables) => variables,
  evictFields: ['wizard'],
});
